import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Building2, Users, MapPin, Phone, Mail, Globe, Save } from 'lucide-react';

const Unternehmen = () => {
  const [companyData, setCompanyData] = useState({
    name: 'Autogutachter24 GmbH',
    adresse: 'Musterstraße 123',
    plz: '10115',
    stadt: 'Berlin',
    telefon: '+49 30 12345678',
    email: 'info@autogutachter24.de',
    website: 'www.autogutachter24.de',
    geschaeftsfuehrer: 'Max Mustermann',
    handelsregister: 'HRB 123456',
    steuernummer: 'DE123456789',
    mitarbeiterAnzahl: '15'
  });

  const handleSave = () => {
    console.log('Unternehmensdaten gespeichert:', companyData);
    alert('Unternehmensdaten wurden gespeichert!');
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Unternehmen</h1>
            <p className="text-gray-500 mt-1">Verwalten Sie Ihre Unternehmensinformationen</p>
          </div>
          <Button onClick={handleSave} className="bg-blue-600 hover:bg-blue-700">
            <Save className="w-4 h-4 mr-2" />
            Speichern
          </Button>
        </div>

        {/* Unternehmensübersicht */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center space-x-3">
                <div className="p-3 bg-blue-100 rounded-lg">
                  <Users className="w-6 h-6 text-blue-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Mitarbeiter</p>
                  <p className="text-2xl font-bold text-gray-900">{companyData.mitarbeiterAnzahl}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center space-x-3">
                <div className="p-3 bg-green-100 rounded-lg">
                  <Building2 className="w-6 h-6 text-green-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Standorte</p>
                  <p className="text-2xl font-bold text-gray-900">1</p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center space-x-3">
                <div className="p-3 bg-purple-100 rounded-lg">
                  <Globe className="w-6 h-6 text-purple-600" />
                </div>
                <div>
                  <p className="text-sm text-gray-500">Website</p>
                  <p className="text-lg font-bold text-gray-900">Online</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Unternehmensdaten */}
        <Card>
          <CardHeader>
            <CardTitle>Unternehmensinformationen</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Unternehmensname
                </label>
                <Input
                  value={companyData.name}
                  onChange={(e) => setCompanyData({...companyData, name: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Geschäftsführer
                </label>
                <Input
                  value={companyData.geschaeftsfuehrer}
                  onChange={(e) => setCompanyData({...companyData, geschaeftsfuehrer: e.target.value})}
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Adresse
                </label>
                <Input
                  value={companyData.adresse}
                  onChange={(e) => setCompanyData({...companyData, adresse: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  PLZ
                </label>
                <Input
                  value={companyData.plz}
                  onChange={(e) => setCompanyData({...companyData, plz: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Stadt
                </label>
                <Input
                  value={companyData.stadt}
                  onChange={(e) => setCompanyData({...companyData, stadt: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Phone className="w-4 h-4 inline mr-2" />
                  Telefon
                </label>
                <Input
                  value={companyData.telefon}
                  onChange={(e) => setCompanyData({...companyData, telefon: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Mail className="w-4 h-4 inline mr-2" />
                  E-Mail
                </label>
                <Input
                  type="email"
                  value={companyData.email}
                  onChange={(e) => setCompanyData({...companyData, email: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <Globe className="w-4 h-4 inline mr-2" />
                  Website
                </label>
                <Input
                  value={companyData.website}
                  onChange={(e) => setCompanyData({...companyData, website: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Handelsregister
                </label>
                <Input
                  value={companyData.handelsregister}
                  onChange={(e) => setCompanyData({...companyData, handelsregister: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Steuernummer
                </label>
                <Input
                  value={companyData.steuernummer}
                  onChange={(e) => setCompanyData({...companyData, steuernummer: e.target.value})}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Anzahl Mitarbeiter
                </label>
                <Input
                  type="number"
                  value={companyData.mitarbeiterAnzahl}
                  onChange={(e) => setCompanyData({...companyData, mitarbeiterAnzahl: e.target.value})}
                />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Unternehmen;